module.exports = __webpack_public_path__ + "static/img/keHuSwiper13.cc19ed6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/keHuSwiper13.png
// module id = sQS1
// module chunks = 2